import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const {
  selectItem,
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemRequest,
  deleteItemSuccess,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
} = getReportActions();

const setExternalIdFilter = createAction('setExternalIdFilter');
const downloadEdiFileRequest = createAction('downloadEdiFileRequest');
const setCloLoadFromEDIStatus = createAction('setCloLoadFromEDIStatus');
const cancelLoadFromEDIRequest = createAction('cancelLoadFromEDIRequest');
const acceptLoadFromEDIRequest = createAction('acceptLoadFromEDIRequest');
const acceptLoadFromEDISuccess = createAction('acceptLoadFromEDISuccess');
const declineLoadFromEDIRequest = createAction('declineLoadFromEDIRequest');
const declineLoadFromEDISuccess = createAction('declineLoadFromEDISuccess');

export {
  setReports,
  selectItem,
  setUsedReport,
  setFilterProps,
  setListLoading,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemRequest,
  deleteItemSuccess,
  getItemListRequest,
  getItemListSuccess,
  setTableTitleFilter,
  createReportRequest,
  updateReportRequest,
  setExternalIdFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  downloadEdiFileRequest,
  setCloLoadFromEDIStatus,
  cancelLoadFromEDIRequest,
  acceptLoadFromEDIRequest,
  acceptLoadFromEDISuccess,
  setInitialStateOmitReport,
  declineLoadFromEDIRequest,
  declineLoadFromEDISuccess,
  changeDefaultReportRequest,
};
